import React from "react";
import FormCurrency from "./FormCurrency";
import { Typography } from "@mui/material";

const AddCurrency = ({ handleClose }) => {
  return (
    <div>
      <Typography variant="h4" sx={{ textAlign: "center", mb: 4 }}>
        Add Currency
      </Typography>
      <FormCurrency handleClose={handleClose} />
    </div>
  );
};

export default AddCurrency;
